import React from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import Grid from "@material-ui/core/Grid";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import _ from "lodash";

import SearchField from "../SearchField";
//import Button from '../Button'
import { ListItem, CheckboxInput } from "./CheckboxSelect";
import DropDown from "./index";
import { DropDownIconComponent } from "./icons";
import styles, {
  analyzeTemplate,
  select_class_for_menu
} from "./common_styles";
import menuprops from "./menuProps";
import SearchInput from "../SearchField/components/Inputs/SearchInput";
import ListContainer from "./listUtils.js";
import List from "@material-ui/core/List";

export const ListItemGrouped = React.memo(
  withStyles(theme => ({
    indent_list: {
      paddingLeft: theme.margins.lg + 18
    }
  }))(({ classes, indent, ...props }) => (
    <ListItem className={indent ? classes.indent_list : undefined} {...props} />
  ))
);

export const ListComponentGrouped = React.memo(
  ({
    suggestions,
    search_value,
    selected_value,
    classes,
    groupBy = "region",
    groupedCheck,
    ...props
  }) => {
    const grouped_suggestions = React.useMemo(
      () => _.groupBy(suggestions, groupBy),
      [groupBy, suggestions]
    );

    const onCheckGroup = React.useCallback(key => {
      if (!!groupedCheck.get(key)) {
        props.clearAllFunc(key);
      } else {
        props.selectAllFunc(key);
      }
    });

    return (
      <>
        {Object.keys(grouped_suggestions).map((suggestionKey, id) => (
          <React.Fragment key={`ListItemGrouped-${suggestionKey}-${id}`}>
            <ListItem
              checked={!!groupedCheck.get(suggestionKey)}
              onCheck={() => onCheckGroup(suggestionKey)}
              name={suggestionKey}
              id={`grouped-${suggestionKey}-${id}`}
            />
            {grouped_suggestions[suggestionKey].map((item, id) => (
              <ListItemGrouped
                key={`ListItem-${item.name}-${id}`}
                checked={!!groupedCheck.get(suggestionKey) || undefined}
                selected_value={selected_value}
                onCheck={() => props.onCheck(item, suggestionKey)}
                indent
                {...item}
              />
            ))}
          </React.Fragment>
        ))}
      </>
    );
  }
);

const listComponentStyles = theme => ({
  container: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    maxHeight: 384,
    overflowY: "scroll"
  }
});

export const ListComponent = React.memo(
  ({ suggestions, search_value, selected_value, classes, ...props }) => {
    return (
      <>
        {suggestions.map((item, id) => (
          <ListItem
            key={`ListItem-${item.name}-${id}`}
            selected_value={selected_value}
            onCheck={() => props.onCheck(item)}
            {...item}
          />
        ))}
      </>
    );
  }
);

export const ListComponentWrapper = React.memo(
  withStyles(listComponentStyles)(({ classes, ...props }) => {
    const ListComponent_ = React.useMemo(
      () => (props.groupBy ? ListComponentGrouped : ListComponent),
      [props.groupBy]
    );

    return (
      <ListContainer
        ContainerComponent={List}
        container_props={{ className: classes.container }}
        InnerContainer={React.Fragment}
        ListComponentUnit={ListComponent_}
        maxSuggestions={props.groupBy ? 10000 : undefined}
        {...props}
      />
    );
  })
);

export const ListComponentContainer = React.memo(
  withStyles(theme => ({
    button: {
      textAlign: "center",
      fontSize: 16,
      fontFamily: theme.openSans,
      borderBottom: `1px solid #f0f0f0`,
      padding: "10px",
      flex: 1,
      cursor: "pointer",
      "&:hover": {
        background: "#f5f5f5"
      }
    },
    borderRight: {
      borderRight: `1px solid #f0f0f0`
    },
    container: {
      position: "absolute",
      top: 0,
      bottom: 0,
      overflowY: "scroll",
      height: "100%",
      width: "100%"
    }
  }))(
    ({
      selectAll: selectAllName = "Select All",
      clearAll: clearAllName = "Clear All",
      classes,
      ...props
    }) => {
      return (
        <Grid container direction="column">
          <Grid container>
            <Grid
              item
              xs={6}
              className={`${classes.button} ${classes.borderRight}`}
              onClick={() => props.selectAllFunc()}
            >
              {" "}
              {selectAllName}{" "}
            </Grid>
            <Grid
              item
              className={classes.button}
              onClick={() => props.clearAllFunc()}
            >
              {" "}
              {clearAllName}
            </Grid>
          </Grid>
          <ListComponentWrapper {...props} />
        </Grid>
      );
    }
  )
);

export const MenuSearchInput = React.memo(
  withStyles(theme => ({
    search_list_item: {
      height: "auto !important",
      //padding: theme.margins.xs,
      textAlign: "center",
      "&:hover, &:focus": {
        background: theme.palette.white
      }
    },
    input: {
      background: theme.palette.white,
      padding: `0 8px`,
      border: `1px solid ${theme.palette.lightGrey}`
    }
  }))(({ classes, input_props, handleChange, search_value }) => {
    return (
      <MenuItem classes={{ root: classes.search_list_item }}>
        <FormControl fullWidth>
          <SearchInput
            onChange={handleChange}
            value={search_value}
            className={`${classes.input} ${input_props.input_class || ""}`}
          />
        </FormControl>
      </MenuItem>
    );
  })
);

const search_list_container_styles = theme => ({
  container: {
    width: "100%"
  },
  list_container: {
    paddingBottom: 0
  },
  content: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    overflowY: "auto"
  },
  icon_class_container: {
    marginTop: -2
  },
  root_list_item: {
    cursor: "pointer",
    padding: theme.margins.xs,
    "&:hover": {
      background: theme.palette.lightGrey
    }
  },
  search_list_item: {
    height: "auto !important",
    //padding: theme.margins.xs,
    textAlign: "center",
    "&:hover, &:focus": {
      background: theme.palette.white
    }
  },
  selected: {
    fontWeight: theme.fontWeight.bold
  },
  input: {
    background: theme.palette.white,
    padding: `0 8px`,
    border: `1px solid ${theme.palette.lightGrey}`
  },
  paper: {
    borderRadius: 0,
    border: `1px solid ${theme.palette.lightGrey}`,
    boxShadow: "0px 4px 5px #eee",
    background: theme.palette.white,
    width: "100%"
  },
  disabled: {},
  focused: {},
  error: {},
  search_input_root: {
    lineHeight: 1.5,
    fontSize: 16
  },
  underline: {
    "&:before": {
      borderBottom: `1px solid ${theme.palette.lightGrey}`
    },
    "&:hover:not($disabled):not($focused):not($error):before": {
      borderBottomColor: theme.palette.mediumGrey
    },
    "&:after": {
      borderBottom: `1px solid ${theme.palette.deepGrey}`
    }
  },
  list_container: {
    paddingBottom: 0
  },

  label: {
    //  marginTop: 6
  },
  full_width_xs: {
    maxWidth: "100%"
  }
});
const DropDownContainer = React.memo(
  withStyles(search_list_container_styles)(
    ({
      classes,
      default_search_value,
      search_value,

      container_width,
      container_class,

      handleChange,

      has_add_fields,
      add_fields_label,
      add_fields_action,

      input_props = {},
      children,
      onSelect,
      DropDownIconComponent,
      renderValue = "select",
      full_width_xs,
      icon_component,
      icon_adornment_size,
      ...props
    }) => {
      const [select_ref, set_ref] = React.useState(null);
      const [menuprops_] = React.useState(() =>
        menuprops({
          direction: "left",
          style: { maxHeight: 800 }
        })
      );

      const [im_hovered_upon, setHover] = React.useState(false);

      const dropDownComponentProps = {
        size: "sm",
        dropdown_icon: "icon-down-arrow"
      };

      const setHover_ = React.useCallback(value => {
        if (im_hovered_upon === value) {
          return;
        }
        setHover(value);
      });

      const cancel = React.useCallback(function() {
        handleChange({ target: { value: "" } }); // clear the selection
        set_ref(null);
        setHover_(false);
      });

      const smDown = useMediaQuery("(max-width:600px)");

      return (
        <>
          <FormControl
            fullWidth={full_width_xs && smDown}
            onMouseEnter={_.debounce(() => setHover_(true), 100)}
            onMouseLeave={_.debounce(() => setHover_(false), 100)}
            onClick={e => set_ref(e.currentTarget)}
          >
            <Select
              open={false}
              value={renderValue}
              renderValue={() => renderValue}
              input={
                <CheckboxInput
                  im_hovered_upon={im_hovered_upon}
                  icon_component={icon_component}
                  icon_adornment_size={icon_adornment_size}
                />
              }
              IconComponent={() => (
                <DropDownIconComponent {...dropDownComponentProps} />
              )}
            />
          </FormControl>
          <Menu
            anchorEl={select_ref}
            keepMounted
            open={Boolean(select_ref)}
            onClose={cancel}
            value={search_value}
            marginThreshold={0}
            {...menuprops_}
            classes={{
              paper:
                classes.paper +
                (full_width_xs ? " " + classes.full_width_xs : "") +
                (container_class ? " " + container_class : "")
            }}
          >
            <div>
              <MenuSearchInput
                input_props={input_props}
                handleChange={handleChange}
                search_value={search_value}
              />
            </div>
            {children}
          </Menu>
        </>
      );
    }
  )
);

const CheckboxField = ({
  classes,
  handleChange,
  values,
  selected_value,
  selectAll,
  clearAll,
  default_search_value,
  selected_field = "",
  full_width_xs,
  icon_component,
  icon_adornment_size,
  groupBy
}) => {
  const [suggestions, setSuggestions] = React.useState([]);
  const [status, setStatus] = React.useState("");
  const [forceSetList, setList] = React.useState(null);
  const [selected_value_, setSelected] = React.useState(selected_value || []);
  const [selected_all, set_selected_all] = React.useState(false);

  // for grouped checkbox
  const [groupedCheck] = React.useState(new Map());

  React.useEffect(() => {
    Object.keys(_.groupBy(suggestions, groupBy)).forEach(key => {
      groupedCheck.set(key, false);
    });
  }, [suggestions]);

  React.useEffect(() => {
    if (values[0].id) {
      setSuggestions(values);
    } else {
      setSuggestions(values.map((name, id) => ({ name, id: `${id}` })));
    }
  }, [values]);

  React.useEffect(() => {
    if (Array.isArray(selected_value)) {
      setSelected(selected_value);
    } else if (typeof selected_value === "string") {
      setSelected(selected_value.split(","));
    }
  }, [selected_value]);

  const onCheck = React.useCallback((value, key) => {
    let value_;

    if (selected_value_.find(o => o.id == value.id)) {
      value_ = selected_value_.filter(o => o.id !== value.id);
      if (key) {
        groupedCheck.set(key, false);
      }
    } else {
      value_ = selected_value_.concat(value);
    }

    setSelected(value_);

    if (handleChange && typeof handleChange === "function") {
      handleChange(value_);
    }
  });

  function selectAllGrouped(new_selection, selected_values) {
    let result = selected_values.slice();
    for (let s of new_selection) {
      if (result.find(o => o.id === s.id)) {
        continue;
      }
      result.push(s);
    }
    return result;
  }

  const selectAllFunc = React.useCallback(key => {
    const selected =
      groupBy && key
        ? selectAllGrouped(
            suggestions.filter(o => o[groupBy] === key),
            selected_value_
          )
        : suggestions;

    if (key) {
      groupedCheck.set(key, true);
    } else {
      groupedCheck.forEach((value, key) => {
        groupedCheck.set(key, true);
      });
    }

    setSelected(selected);
    if (handleChange && typeof handleChange === "function") {
      handleChange(selected);
    }
  });

  const clearAllFunc = React.useCallback(key => {
    const cleared =
      groupBy && key ? selected_value_.filter(o => o[groupBy] !== key) : [];

    if (key) {
      groupedCheck.set(key, false);
    } else {
      groupedCheck.forEach((value, key) => {
        groupedCheck.set(key, false);
      });
    }

    //  setList(suggestions);
    setSelected(cleared);
    if (handleChange && typeof handleChange === "function") {
      handleChange(cleared);
    }
  });

  // const handleChange_ = React.useCallback(() => {
  //   if (Array.isArray(forceSetList)) { setList(null) }
  // })

  const renderValue = React.useMemo(
    () => analyzeTemplate(selected_field, selected_value_.length),
    [selected_field, selected_value_]
  );

  //            forceSetList          = {forceSetList}

  return (
    <SearchField
      type="search-select-field"
      fetch_type="no-fetch"
      Container={DropDownContainer}
      ListComponent={ListComponentContainer}
      suggestions={suggestions}
      selected_value={selected_value_}
      default_search_value={default_search_value}
      style={{ paddingBottom: 0 }}
      onCheck={onCheck}
      selectAll={selectAll}
      clearAll={clearAll}
      selectAllFunc={selectAllFunc}
      clearAllFunc={clearAllFunc}
      container_class={classes.container_class}
      renderValue={renderValue}
      initial_open
      full_width_xs={full_width_xs}
      icon_component={icon_component}
      icon_adornment_size={icon_adornment_size}
      groupBy={groupBy}
      groupedCheck={groupedCheck}
      DropDownIconComponent={() => (
        <DropDownIconComponent size="sm" dropdown_icon="icon-down-arrow" />
      )}
    />
  );
};

export default React.memo(
  withStyles(theme => ({
    container_class: {
      maxWidth: "100%", //"calc(100% - 40px)",
      [theme.breakpoints.up("sm")]: {
        maxWidth: 400
      }
    },
    icon: {
      right: "auto",
      margin: "0 16px"
    }
  }))(CheckboxField)
);
